import React from 'react';
import { S as Skeleton } from './Skeleton-RKr5mJai.js';

const FeaturedProductSkeleton = () => (React.createElement("div", { className: "swiper-slide", style: { width: '80%' } },
    React.createElement("div", { className: "featured-product", style: { background: 'none' } },
        React.createElement("div", { className: "upsell-items-link" },
            React.createElement("div", { className: "img" },
                React.createElement(Skeleton, { width: "100%", height: 100, marginBottom: 15 })),
            React.createElement("div", { className: "inner-wrapper" },
                React.createElement(Skeleton, { width: "70%", marginBottom: 15 }),
                React.createElement(Skeleton, { width: 50, marginBottom: 15 }),
                React.createElement(Skeleton, { width: "90%", height: 50, marginBottom: 15 }))))));

export { FeaturedProductSkeleton as F };
//# sourceMappingURL=FeaturedProductSkeleton-dpwqH2FM.js.map
